export default __webpack_public_path__ + "static/mobile_dock_m-f1fcab73fcd819fe98e4f9c3ed8e9b00.png";